import { useEffect, useState } from "react";
import api from "@/lib/api";

let CURRENT = { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, label: "", source: "browser" };
const subs = new Set();

export const getUserTz = () => CURRENT.timezone;
export function loadUserTz() {
  return api.get("/me/timezone").then((r) => { CURRENT = r.data; subs.forEach((f) => f(CURRENT)); return CURRENT; }).catch(() => CURRENT);
}
export function useUserTz() {
  const [tz, setTz] = useState(CURRENT);
  useEffect(() => { subs.add(setTz); if (!CURRENT.label) loadUserTz(); return () => { subs.delete(setTz); }; }, []);
  return tz;
}

const asDate = (v) => new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(String(v)) || String(v).length <= 10 ? v : `${v}Z`);
export const fmtTimeTz = (v, tz = getUserTz()) => asDate(v).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit", timeZone: tz });
export const dateKeyTz = (v, tz = getUserTz()) => (String(v).length <= 10 ? String(v) : asDate(v).toLocaleDateString("en-CA", { timeZone: tz }));
export const timeHHMMTz = (v, tz = getUserTz()) => asDate(v).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: tz });
export const tzAbbr = (v, tz = getUserTz()) => new Intl.DateTimeFormat(undefined, { timeZone: tz, timeZoneName: "short" }).formatToParts(asDate(v)).find((p) => p.type === "timeZoneName")?.value || tz;

export function zonedToUtcIso(date, time, tz = getUserTz()) {
  const guess = new Date(`${date}T${time}:00Z`);
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: tz, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" })
    .formatToParts(guess).map((p) => [p.type, p.value]));
  const asIfUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
  return new Date(guess.getTime() - (asIfUtc - guess.getTime())).toISOString().replace(".000Z", "+00:00");
}
